module.exports = __webpack_public_path__ + "img/file_icon_circle.a387cb8f.svg";